import classNames from "classnames";
import styles from "./styles.module.css";
import { ButtonProps } from "@mui/material";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { DownloadIcon } from "../../../../shared/icons/DownloadIcon";

interface Props extends ButtonProps {
  onDownload: () => void;
  isDisabled?: boolean;
  className?: string;
}

export const DownloadFileButton = ({
  onDownload,
  isDisabled,
  className,
  ...rest
}: Props) => {
  const cls = classNames(styles.button, styles["download-button"], className);

  return (
    <AppIconButton
      disabled={isDisabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDownload();
      }}
      className={cls}
      {...rest}
    >
      <DownloadIcon />
    </AppIconButton>
  );
};
